import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	max-width: 1366px;
	margin: 0 auto;
	text-align: left;
	padding: 0 5em 5em 5em;

	.title {
		margin: 0 0 1em 0;
		font-size: 1em;
	}

	@media all and (max-width: ${vars.mobileL}) {
		padding: 0em 2em 5em 2em;

	}
`;
